import request from '@/utils/request'
import API from './api'

//题目管理--查超纲

// 查超纲任务列表
export function getCheckBeyondLevelListAPI(data){
	return request({
		url: API.GET_CHECK_BEYOND_LEVEL_LIST,
	    method: 'post',
	    data
	});
}



//修改任务状态-修改任务状态：提交、入库、删除
export function modifyCheckBeyondLevelStatusAPI(stage_type,modifyType,data) {
 
  let url='',
  	 actionKey=`${stage_type}_${modifyType}`,
 	 urlMap={
	  	'checking_submit':API.BEYONGD_CHECKING_SUBMIT,//进行中-提交
	  	'checking_delete':API.BEYONGD_CHECKING_DELETE,//进行中-删除
	  	'check_finish_submit':API.BEYONGD_CHECK_FINISH_SUBMIT,//审核完成-提交
	  }

  return request({
    url: urlMap[actionKey],
    method: 'post',
    data
  })
}



// 审查人列表
export  function getCheckBeyondLevelUserListAPI(data){
	return request({
		url: API.GET_CHECK_BEYOND_LEVEL_USER_LIST,
	    method: 'post',
	    data
	});
}

// 分配审查人
export  function assignBeyondCheckUserAPI(data){
	return request({
		url: API.ASSIGN_BEYONGD_CHECK_USER,
	    method: 'post',
	    data
	});
}
// 创建任务
export  function createCheckBeyondLevelTaskAPI(data){
	return request({
		url: API.CREATE_CHECK_BEYOND_LEVEL_TASK,
	    method: 'post',
	    data
	});
}


/*查超纲*/

// 更改题目状态
export const setStageAPI = (data) => {
	return request({
		url: API.SET_STAGE,
	    method: 'post',
	    data
	});
}

// 获取题目列表
export const getSuperClassQuestionListAPI = (data) => {
	return request({
		url: API.GET_SUPERCLASS_QUESTION_LIST,
	    method: 'post',
	    data
	});
}
// 获取知识点列表
export const getSuperClassQuestionFilterAPI = (data) => {
	return request({
		url: API.GET_SUPERCLASS_QUESTION_filter,
	    method: 'post',
	    data
	});
}

// 获取章节树列表
export const getSuperClassTreeListAPI = (data) => {
	return request({
		url: API.GET_SUPERCLASS_TREE_LIST,
	    method: 'post',
	    data
	});
}


// WEBPACK FOOTER //
// ./src/API/check-beyond-level.js